import { Loader, type LoaderProps } from '@mantine/core'
import clsx from 'clsx'
import styles from './PageLoading.module.css'

export interface PageLoadingProps extends LoaderProps {
	inline?: boolean
}

export default function PageLoading({ inline = false, className, ...props }: PageLoadingProps) {
	return <Loader className={clsx(inline ? styles.inline : styles.fixed, className)} {...props} />
}
